import * as React from "react";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import { IApplicationState } from "../../redux/root-reducer";
import { Role } from "../types";

export interface IVisibleForProps {
  roles: Role[];
  child: React.ReactNode;
}

export interface IVisibleForStateProps {
  currentUserRole: Role | undefined;
}

const getStateProps = createSelector(
  (state: IApplicationState) => state.auth,
  (authState) => ({
    currentUserRole: authState.currentUser?.role,
  })
);

const isChildrenVisibleToUser = (
  currentUserRole: Role | undefined,
  allowedRoles: Role[]
) => {
  if (!currentUserRole) return false;

  return allowedRoles.some((role) => role === currentUserRole);
};

const VisibleFor: React.FC<IVisibleForProps> = (props) => {
  const { currentUserRole } = useSelector(getStateProps);
  const { roles, child } = props;

  return (
    <>
      {isChildrenVisibleToUser(currentUserRole, roles) &&
        child &&
        // @ts-ignore
        React.cloneElement(child, { ...props })}
    </>
  );
};

export default VisibleFor;
